import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import banner1 from "../../assets/Banners/TopSaleImage/AIRPURIFIER1.png";
import banner2 from "../../assets/Banners/TopSaleImage/AIRPURIFIER2.png";
import banner3 from "../../assets/Banners/TopSaleImage/AIRPURIFIER3.png";
import { AddToCart } from '../../redux/slices/AddTocartSlice';
import { viewCartData } from '../../redux/slices/ViewCartSlice';
import { useNavigate } from 'react-router-dom';
import Footer from '../../Fotter';
import { fetchProducts } from '../../redux/slices/AllProductSlice';
import { ProductById } from '../../redux/slices/ProductByIdSlice';
import LoaderPage from '../Loader';

const TopSellDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false)
  const [_id, setId] = useState('')

  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);

  const bannerImages = [
    banner1,
    banner2,
    banner3
  ];

  useEffect(() => {
    setLoader(true);
    const url =
      "https://www.addmecart.com/shop/home-electronics/air-purifier/xiaomi-4-lite-smart-air-purifier-for-home-aqi-display-hepa-carbon-filter";
    const extractedTitle = url?.split("/").filter(Boolean).pop();
    const fetchData = async () => {
      try {
        if (extractedTitle) {
          const response = await dispatch(ProductById(extractedTitle));
          const productData = response?.payload?.product;
          const productId = productData?._id;
          setId(productId)
        }
      } catch (error) {
        setLoader(true);
        console.error("Error fetching product-related data:", error);
      } finally {
        setLoader(false);
      }
    };
    fetchData();
  }, [dispatch]);

  const handleAddToCartBuy = () => {
    const cartData = {
      productId: _id,
      quantity: 1,
    };
    dispatch(AddToCart(cartData)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(viewCartData());
        navigate("/cart");
      } else {
        console.log("Responce Error");
      }
    });
  };

  return (
    <div>
      <div className="w-full px-4 md:px-10 sm:mt-28  mt-20 sm:space-y-10 space-y-4">
        {bannerImages?.map((img, idx) => (
          <div className="w-full flex justify-center">
            <div className="relative rounded-md   border border-gray-300
            w-full h-[180px] sm:h-[240px] md:h-[300px] lg:h-[700px] overflow-hidden shadow-md transition-transform duration-300 ease-in-out">
              <img
                src={img}
                alt={`Banner ${idx + 1}`}
                className="w-full h-full object-fill"
              />

              {(idx === 0 || idx === 1 || idx === 2) && (
                <div className="absolute left-1/2 bottom-2 transform -translate-x-1/2 sm:left-5 sm:translate-x-0">
                  <button onClick={() => handleAddToCartBuy()} className="bg-gradient-to-r from-yellow-400 to-pink-500 text-white text-sm sm:text-lg font-bold px-4 sm:px-10 py-2 sm:py-3 
          rounded-md shadow-lg hover:scale-105 transition-all duration-300">
                    Buy Now
                  </button>
                </div>
              )}
            </div>
          </div>

        ))}

      </div>
      <div className='mt-5'>
        <Footer />
      </div>
      {loader && <LoaderPage />}
    </div>
  );
};

export default TopSellDetails;
